const AddStudents = () => {
    // Dummy data
    const data = [
        {
            id: "#0022",
            photo: "/assests/student1.png",
            name: "Jessia Rose",
            gender: "Female",
            class: "1",
            section: "A",
            parents: "Maria Jamans",
            address: "59 Australia, Sydney",
            dateOfBirth: "02/05/2001",
            phone: "+123 9988568",
            email: "kazifahim93@gmail.com",
        },
        {
            id: "#0022",
            photo: "/assests/student2.png",
            name: "Jessia Rose",
            gender: "Female",
            class: "1",
            section: "A",
            parents: "Maria Jamans",
            address: "59 Australia, Sydney",
            dateOfBirth: "02/05/2001",
            phone: "+123 9988568",
            email: "kazifahim93@gmail.com",
        },
        {
            id: "#0022",
            photo: "/assests/student3.png",
            name: "Jessia Rose",
            gender: "Female",
            class: "1",
            section: "A",
            parents: "Maria Jamans",
            address: "59 Australia, Sydney",
            dateOfBirth: "02/05/2001",
            phone: "+123 9988568",
            email: "kazifahim93@gmail.com",
        },
        {
            id: "#0022",
            photo: "/assests/student2.png",
            name: "Jessia Rose",
            gender: "Female",
            class: "1",
            section: "A",
            parents: "Maria Jamans",
            address: "59 Australia, Sydney",
            dateOfBirth: "02/05/2001",
            phone: "+123 9988568",
            email: "kazifahim93@gmail.com",
        },
        {
            id: "#0022",
            photo: "/assests/student3.png",
            name: "Jessia Rose",
            gender: "Female",
            class: "1",
            section: "A",
            parents: "Maria Jamans",
            address: "59 Australia, Sydney",
            dateOfBirth: "02/05/2001",
            phone: "+123 9988568",
            email: "kazifahim93@gmail.com",
        },
    ];

    return (
        <div className="bg-gray-100">
            <div className="mt-4 space-y-4 px-4">
                <h1 className="text-xl">Students</h1>
                <span className="flex space-x-2">
                    <h2>Home &gt;</h2>
                    <h2>All Students</h2>
                </span>
            </div>
            <div className="px-8">

                <div className="px-4 mt-8 mb-12 ">
                    <span className="flex justify-between md:py-4 max-[760px]:pt-4 py-4 place-items-center">
                        <h1 className="font-bold text-xl">All Students Data</h1>
                        <h1>...</h1>
                    </span>
                    <div className="md:flex md:justify-between">
                        <form className="md:flex-1 flex flex-col md:flex-row space-y-2 px-6 md:justify-between">
                            <input type="text" placeholder="Search by Roll"
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            <input type="text" placeholder='Search by Name'
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            <input type="text" placeholder="Class"
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </form>
                        <button className="bg-yellow-500 max-[760px]:mt-8  max-[760px]:w-full  text-white py-4 md:px-8 ">SEARCH</button>
                    </div>
                </div>


                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead>
                            <tr>
                                <th className="px-6 py-3 bg-gray-200 text-left">Roll</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Photo</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Name</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Gender</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Class</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Section</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Parents</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Address</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Date Of Birth</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">Phone</th>
                                <th className="px-6 py-3 bg-gray-200 text-left">E-mail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.id}</td>
                                    <td className="px-6 py-4 whitespace-nowrap"><img src={item.photo} alt={item.name} /></td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.gender}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.class}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.section}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.parents}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.address}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.dateOfBirth}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.phone}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default AddStudents;